/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DisplayTypeEnum } from './DisplayTypeEnum';
import {
    DisplayTypeEnumFromJSON,
    DisplayTypeEnumFromJSONTyped,
    DisplayTypeEnumToJSON,
    DisplayTypeEnumToJSONTyped,
} from './DisplayTypeEnum';
import type { GenericColors } from './GenericColors';
import {
    GenericColorsFromJSON,
    GenericColorsFromJSONTyped,
    GenericColorsToJSON,
    GenericColorsToJSONTyped,
} from './GenericColors';

/**
 * 
 * @export
 * @interface NotificationResponse
 */
export interface NotificationResponse {
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    subtitle?: string;
    /**
     * 
     * @type {GenericColors}
     * @memberof NotificationResponse
     */
    color?: GenericColors;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    message: string;
    /**
     * 
     * @type {DisplayTypeEnum}
     * @memberof NotificationResponse
     */
    displayType: DisplayTypeEnum;
}



/**
 * Check if a given object implements the NotificationResponse interface.
 */
export function instanceOfNotificationResponse(value: object): value is NotificationResponse {
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('displayType' in value) || value['displayType'] === undefined) return false;
    return true;
}

export function NotificationResponseFromJSON(json: any): NotificationResponse {
    return NotificationResponseFromJSONTyped(json, false);
}

export function NotificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'subtitle': json['subtitle'] == null ? undefined : json['subtitle'],
        'color': json['color'] == null ? undefined : GenericColorsFromJSON(json['color']),
        'message': json['message'],
        'displayType': DisplayTypeEnumFromJSON(json['displayType']),
    };
}

export function NotificationResponseToJSON(json: any): NotificationResponse {
    return NotificationResponseToJSONTyped(json, false);
}

export function NotificationResponseToJSONTyped(value?: NotificationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'subtitle': value['subtitle'],
        'color': GenericColorsToJSON(value['color']),
        'message': value['message'],
        'displayType': DisplayTypeEnumToJSON(value['displayType']),
    };
}

